import { HttpClient } from '../HttpClient';
/**
 * * Post Job Request
 */
export const PostJobRequestForm = async (formData) => {
  try {
    const { data } = await HttpClient.post(`api/jobrequisitions`, { ...formData });
    return await Promise.resolve(data);
  } catch (err) {
    return Promise.reject(err);
  }
};
